import { useState, useEffect } from "react";

const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => setDebouncedValue(value), delay);
    return () => clearTimeout(handler);
  }, [value, delay]);

  return debouncedValue;
};

const InputComponent = (props) => {
  
  const [input, setInput] = useState(props.value || "");
  const debouncedInput = useDebounce(input, 500);

  
  useEffect(() => {
    setInput(props.value || "");
  }, [props.value]);

  useEffect(() => {
    if (debouncedInput !== undefined) {
      props.onChange(debouncedInput);
    }
  }, [debouncedInput]);

  return (
    <div className={props.className}>
      <input
        className="form-control"
        placeholder={props.placeholder}
        onChange={(e) => setInput(e.target.value)}
        value={input}
      />
    </div>
  );
};

export default InputComponent;